import React from "react";
import PropTypes from "prop-types";
import BaseInput from "../../../../components/BaseInput";
import RadioGenders from "../../../../components/RadioGenders";
import BaseButton from "../../../../components/BaseButton";
import useController from "./controller";
import BaseTextButton from "../../../../components/BaseTextButton";
import BirthDayDatePicker from "../../../RegisterPage/components/BirthDayDatePicker";
import { useTranslation } from "react-i18next";
import RemoveUser from "../../../../modals/RemoveUser";
import "./style.scss";

export default function EditProfileForm({ deactivateEditProfile }) {
  EditProfileForm.propTypes = {
    deactivateEditProfile: PropTypes.func.isRequired,
  };

  const {
    onSubmitForm,
    isSaving,
    isEdit,
    handleChange,
    getValidGenders,
    onComparableTextHandle,
    comparableText,
    onPassHandleChange,
    password,
    isValidEmail,
    isConsistency,
    editFormData,
    isBirthdayValid,
    validBirthdayIfExist,
    onBirthdayHandle,
    showDeleteProfilePopup,
  } = useController(deactivateEditProfile);
  const { t } = useTranslation();
  return (
    <div className="edit-profile-wrapper">
      <form
        onSubmit={onSubmitForm}
        className="edit-profile-wrapper__update-profile-form"
        action=""
      >
        <div className="register-page__person-info">
          <BaseInput
            id="update-name"
            onChange={handleChange}
            name="firstName"
            value={editFormData.firstName}
            autocomplete="off"
            maxlength={20}
            type="text"
            label={t("name_label")}
          />
          <RadioGenders
            formData={editFormData}
            gender={editFormData.gender}
            onChange={handleChange}
            getValidGenders={getValidGenders}
          />
        </div>
        <BirthDayDatePicker
          onBirthdayHandle={onBirthdayHandle}
          birthDay={editFormData.birthday}
          isBirthdayValid={isBirthdayValid}
        />
        <BaseInput
          name="email"
          value={editFormData.email}
          id="update-email"
          onChange={handleChange}
          type="email"
          label={t("email_label")}
          autocomplete="off"
          errorMessage={!isValidEmail ? t("register_page.email_validate") : ""}
        />
        <BaseInput
          id="update-pass"
          onChange={onPassHandleChange}
          value={password}
          name="password"
          type="password"
          label={t("new_password_label")}
        />
        <BaseInput
          id="update-repeat-pass"
          onChange={onComparableTextHandle}
          name="repeat_pass"
          value={comparableText}
          type="password"
          label={t("repeat_password_label")}
          errorMessage={!isConsistency ? t("register_page.same_pass") : ""}
        />
        <div className="edit-profile-wrapper__update-profile-form__actions">
          <BaseButton
            disabled={!isConsistency || !validBirthdayIfExist()}
            type="submit"
            loading={isSaving}
            unfilledGray={!isEdit}
            className="edit-profile-wrapper__update-profile-form__actions__save"
          >
            {t("save")}
          </BaseButton>
          {/*<BaseTextButton*/}
          {/*  type="button"*/}
          {/*  onClick={deactivateEditProfile}*/}
          {/*  className="edit-profile-wrapper__update-profile-form__actions__cancel"*/}
          {/*>*/}
          {/*  {t("cancel")}*/}
          {/*</BaseTextButton>*/}
          <BaseButton
            className="edit-profile-wrapper__update-profile-form__actions__delete"
            unfilledGray
            type="submit"
            onClick={showDeleteProfilePopup}
          >
            {t("deleteProfile")}
          </BaseButton>
        </div>
      </form>
      <RemoveUser />
    </div>
  );
}
